// extracted by mini-css-extract-plugin
export default {"root":"restrict-by-capacity_root__MSP96","scrollbars":"restrict-by-capacity_scrollbars__esQ9b","placeHolderShimmer":"restrict-by-capacity_placeHolderShimmer__TV3AE"};